const _excluded = ["children"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { get } from '../../../utils/getPropertyByPath';
import ReactSelect, { components } from 'react-select';
import { getGlobalDictionaryTerm } from '../../../utils';
import addQueryString, { addQueryStringMultiple } from '../../Listing';
import { ReactComponent as IconCheckBoxWhite } from '../../../resources/icons/IconCheckBoxWhite.svg';
import { ReactComponent as IconCheckBox } from '../../../resources/icons/IconCheckBox.svg';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
const getOptions = unMappedOptions => {
  if (unMappedOptions && unMappedOptions.values && unMappedOptions.values.length) {
    return unMappedOptions.values.map(tagOption => {
      const option = get(tagOption, 'title.value') || get(tagOption, 'name');
      return {
        label: option,
        value: option
      };
    });
  }
  return [];
};
const CustomMultiValue = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: "plus"
  }, children);
};
const CustomOption = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(components.Option, props, /*#__PURE__*/React.createElement("label", {
    className: "labelOption",
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      position: "relative",
      paddingLeft: props.isMulti ? "35px" : "0",
      marginBottom: "0",
      cursor: "pointer",
      fontSize: "22px",
      userSelect: "none",
      paddingBottom: "8px"
    }
  }, props.isMulti ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onClick: e => e.stopPropagation(),
    style: {
      position: "absolute",
      opacity: "0",
      cursor: "pointer",
      height: "0",
      width: "0"
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      left: "0",
      height: "25px",
      width: "25px",
      border: "1px solid gray",
      borderRadius: "5px"
    }
  }, props.isSelected ? /*#__PURE__*/React.createElement(IconCheckBox, {
    style: {
      color: "black",
      width: "10px"
    }
  }) : null)) : null, children, props.isSelected ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "16px",
      height: "16px",
      borderRadius: "50%",
      background: "currentColor"
    }
  }, /*#__PURE__*/React.createElement(IconCheckBoxWhite, {
    style: {
      width: "7px"
    }
  })) : null));
};
const SurpriseWizardSelect = _ref3 => {
  let {
    selectData,
    setIsSomeSelectOpen,
    setRemovedOldQueryString,
    eventsAnalyticsData,
    params
  } = _ref3;
  const history = useHistory();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const fieldName = get(selectData, 'title.jss.value');
  const fieldTypeItem = get(selectData, "fieldTypeItem.item.fieldType.value");
  const sitecoreContext = useSitecoreContext();
  const selectLabel = getGlobalDictionaryTerm(sitecoreContext, 'select') || 'Select';
  const isMulti = fieldTypeItem === "Dropdown Multi Select";
  let tagsOptions = [];
  tagsOptions = getOptions(get(selectData, "tagsToDisplay"));
  const resetUrlParams = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete(fieldName);
    history.replace(`${history.location.pathname}${url.search}`);
    setRemovedOldQueryString(true);
  };
  useEffect(() => {
    resetUrlParams();
    const preselectedTags = getOptions(get(selectData, "preselectedTags"));
    setSelectedOptions(preselectedTags);
    pushToUrlParams(preselectedTags, undefined);
  }, []);
  const pushToUrlParams = (selectedFields, removedValue) => {
    if (selectedFields === null) {
      // delete last item in array
      addQueryStringMultiple(fieldName, [], history, true);
      return;
    }
    if (Array.isArray(selectedFields)) {
      if (selectedFields.length && removedValue === undefined) {
        // add multi item when isMulti={true}
        addQueryStringMultiple(fieldName, selectedFields.map(_ref4 => {
          let {
            value
          } = _ref4;
          return value;
        }), history, true);
        return;
      }
      // delete item or all items
      addQueryStringMultiple(fieldName, selectedFields.map(_ref5 => {
        let {
          value
        } = _ref5;
        return value;
      }), history, true);
      return;
    }
    // add single item when isMulti={false}
    addQueryString(fieldName, selectedFields.value, history);
  };
  const handleChange = (selectedFields, _ref6) => {
    let {
      removedValue
    } = _ref6;
    setSelectedOptions(selectedFields);
    pushToUrlParams(selectedFields, removedValue);
    if (Array.isArray(selectedFields) && selectedFields.length) {
      const analyticsTextFields = selectedFields.map(_ref7 => {
        let {
          value
        } = _ref7;
        return value;
      }).join(", ");
      tealiumClickFunc(tealiumMergeClickData(eventsAnalyticsData, params), analyticsTextFields);
      return;
    }
    if (Object.keys(selectedFields).length) {
      // @ts-ignore
      tealiumClickFunc(tealiumMergeClickData(eventsAnalyticsData, params), selectedFields.value);
    }
  };
  const customStyles = {
    dropdownIndicator: base => _objectSpread(_objectSpread({}, base), {}, {
      color: "var(--main-color)",
      background: "white",
      borderRadius: "50%",
      marginLeft: "6px",
      "svg": {
        ".contrast &, .dark &": {
          fill: "#000000"
        }
      }
    }),
    control: base => _objectSpread(_objectSpread({}, base), {}, {
      background: "#ECF6FA",
      border: 0,
      borderRadius: "30px",
      padding: "5px 10px",
      boxShadow: "none",
      ".contrast &, .dark &": {
        color: "#ffffff",
        backgroundColor: " #4D4D4D"
      }
    }),
    valueContainer: base => _objectSpread(_objectSpread({}, base), {}, {
      whiteSpace: "nowrap"
    }),
    singleValue: () => ({
      fontWeight: 400,
      color: "black"
    }),
    menu: base => _objectSpread(_objectSpread({}, base), {}, {
      borderRadius: "20px",
      marginTop: "-53px",
      boxShadow: "0px 11px 12px -4px rgba(0, 0, 0, 0.2)"
    }),
    menuList: base => _objectSpread(_objectSpread({}, base), {}, {
      "& div .labelOption": {
        borderBottom: "1px solid #E5E5E5"
      },
      "& div:last-child .labelOption": {
        borderBottom: "none"
      }
    }),
    placeholder: () => ({
      maxWidth: "38vw",
      "@media only screen and (max-width: 1024px)": {
        maxWidth: "54vw"
      },
      overflow: "hidden",
      textOverflow: "ellipsis",
      "white-space": "nowrap"
    }),
    option: (base, state) => _objectSpread(_objectSpread({}, base), {}, {
      backgroundColor: "transparent",
      ":active": {
        backgroundColor: "transparent"
      },
      ".contrast &, .dark &": {
        color: state.isSelected ? "#4D4D4D" : state.isDisabled ? "hsl(0,0%,80%)" : "black"
      },
      color: state.isSelected ? "#9C2677" : state.isDisabled ? "hsl(0,0%,80%)" : "black",
      fontWeight: "bold",
      fontSize: "24px",
      padding: "3px 20px"
    })
  };
  const isOptionDisabled = (option, options) => {
    if (isMulti && Array.isArray(options) && options.length >= 3) {
      return !options.some(el => el.value === option.value);
    }
    return false;
  };
  const handleCloseMenu = () => {
    setIsMenuOpen(false);
    setIsSomeSelectOpen(false);
  };
  const handleOpenMenu = () => {
    setIsMenuOpen(true);
    setIsSomeSelectOpen(true);
  };
  return /*#__PURE__*/React.createElement(ReactSelect, {
    styles: customStyles,
    components: {
      IndicatorSeparator: () => null,
      MultiValueRemove: () => null,
      MultiValue: CustomMultiValue,
      Option: CustomOption
    },
    name: "dealsCurrenncySelector",
    menuPortalTarget: document.body,
    menuIsOpen: isMenuOpen,
    onMenuClose: handleCloseMenu,
    onMenuOpen: handleOpenMenu
    // @ts-ignore
    ,

    isOptionDisabled: (option, options) => isOptionDisabled(option, options),
    id: "dealsCurrenncySelector",
    hideSelectedOptions: false,
    placeholder: `${selectLabel} ${fieldName}`,
    options: tagsOptions,
    value: selectedOptions
    // @ts-ignore
    ,

    onChange: handleChange,
    className: `react-custom-select`,
    isMulti: isMulti,
    isClearable: false,
    isSearchable: false
  });
};
export { SurpriseWizardSelect };